import HrUnavailabilityOverview, { HrUnavailabilityOverviewQueryParams } from "app/models/hrUnavailabilityOverview"
import { Action, Types } from "./hrUnavailabilitiesOverview.actions"

export type HrUnavailabilitiesOverviewState = {
  data: HrUnavailabilityOverview[]
  errors: {}
  params: HrUnavailabilityOverviewQueryParams
  loading: boolean
}

const initialState: HrUnavailabilitiesOverviewState = {
  data: [],
  errors: {},
  loading: false,
  params: {},
}

export default (state = initialState, action: Action): HrUnavailabilitiesOverviewState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
        params: action.payload.params,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.HrUnavailabilitiesOverview,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
